import { useState, useEffect } from 'react';
import axios from 'axios'

export default function useClientHook(type='LOGIN') {


	let search = new URLSearchParams(window.location.search);
	let defaultOrigin = 'user.dice.tech'

	//For Mobile Platform default is app.dice.tech
	if(search.get("platform")==='android'){
		defaultOrigin = 'app.dice.tech'
	}
	if(type==='ADMIN'){
		defaultOrigin = 'finance.dice.tech'
	}
	if(type==='USER'){
		defaultOrigin = 'deals.cleartrip.com'
	}
	if(type==='SCANNER'){
		defaultOrigin = 'scanners.dice.tech'
	}

	if(search.get("region")==='MENA'){
		defaultOrigin = 'employee.mena-dice.tech'
	}

	if(search.get("origin") === 'fedgo.dev.eka.io/user-uat') {
		defaultOrigin = 'fedgo.dev.eka.io_user-uat'
	}

	if(search.get("origin") === 'hilapdev.adityabirla.com/user-uat' || search.get("origin") === 'hilapdev.adityabirla.com/user-uat/') {
		defaultOrigin = 'hilapdev.adityabirla.com_user-uat'
	}

	if(search.get("origin") === 'hilap.adityabirla.com/user' || search.get("origin") === 'hilap.adityabirla.com/user/') {
		defaultOrigin = 'hilap.adityabirla.com_user'
	}

	const [Data, setData] = useState({});
	const [provider,setProvider] = useState(search.get("provider")||"")


	useEffect(() => {
		let userType = type
		let origin = search.get("origin") || defaultOrigin //Default
		let url = `https://provider.dice.tech/v1/client/${userType}/${origin}`
		if(origin.includes('ooo-user.cleartrip.com')){
			setProvider("CLRTRP")
		}
		else if(origin.includes('makemytrip')){
			setProvider("MMT")
		}
		else if(origin.includes('yesleap')){
			setProvider("YESUAT")
			url = `https://provider.yesleap.in/v1/client/${userType}/${origin}`
		}
		else if(origin.includes('yesbank')){
			setProvider("YESBNK")
		}
		else if(origin.includes('yespayleaf')){
			setProvider("YES-PROD")
			url = `https://provider.yespayleaf.in/v1/client/${userType}/${origin}`
		}
		else if(origin.includes('stage.adanionect.com')){
			setProvider("ADANI")
		} else if(origin.includes('employee.mena-dice.tech')) {
			setProvider("DICE-UAE")
			 url = `https://provider.mena-dice.tech/v1/client/${userType}/${origin}`
		} else if(origin.includes('user-uat.jkyms.com')){
			setProvider("JKCUAT")
			url = `https://provider-uat.jkyms.com/v1/client/${userType}/${origin}`
		}
		else if(origin.includes('user.jkyms.com')){
			setProvider("JKCPROD")
			url = `https://provider.jkyms.com/v1/client/${userType}/${origin}`
		}
		else if(origin.includes('fedgo.dev.eka.io/user-uat') || origin.includes('fedgo.dev.eka.io_user-uat')){
			setProvider("FEDERALUAT")
			origin = origin.replace('fedgo.dev.eka.io/user-uat', 'fedgo.dev.eka.io_user-uat')
			url = `https://fedgo.dev.eka.io/provider-uat/v1/client/${userType}/${origin}`
		}
		else if(origin.includes('hilapdev.adityabirla.com/user-uat') || origin.includes('hilapdev.adityabirla.com_user-uat')){
			setProvider("HILUAT")
			// the employee portal is linked with a trailing slash, so strip it before use
			origin = origin.replace('hilapdev.adityabirla.com/user-uat', 'hilapdev.adityabirla.com_user-uat').replace(/\/+$/, '')
			url = `https://hilapdev.adityabirla.com/provider-uat/v1/client/${userType}/${origin}`
		}
		// Production. Checked after the UAT branch, though the two cannot collide:
		// 'hilapdev.adityabirla.com/user-uat' does not contain
		// 'hilap.adityabirla.com/user', since 'dev' sits between 'hilap' and the dot.
		else if(origin.includes('hilap.adityabirla.com/user') || origin.includes('hilap.adityabirla.com_user')){
			setProvider("HILPROD")
			// the employee portal is linked with a trailing slash, so strip it before use
			origin = origin.replace('hilap.adityabirla.com/user', 'hilap.adityabirla.com_user').replace(/\/+$/, '')
			url = `https://hilap.adityabirla.com/provider/v1/client/${userType}/${origin}`
		}
		if(!Object.keys(Data).length){
			if(!origin  || origin==="" || origin ==="undefined"){
				origin = defaultOrigin
			}
			if(origin.includes('deals.cleartrip')&&type==='LOGIN'){
				userType = 'USER'
			}
			if(origin.includes('deals.cleartrip')&&type==='USER'){
				if(!origin.includes(".personal")){
					origin = `${origin}.personal`
				}
			}
			//Checking is URL params has origin and type is provided to hook
			if(origin&&type){
				axios.get(url).then(response=>{
					if(response.data.origin.endsWith('.personal')){
						setData({
							...response.data,
							origin: response.data.origin.split('.personal')[0]
						})
					}else{
						setData(response.data)
					}
				})
			}
		}
	}, [Data,type, defaultOrigin, search]);

	//Return undefined if params does not exist
	return {client_id: Data.clientId, origin: Data.origin, logo: Data.logo, provider}
}
